import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalConfirm, ModalAlert } from "../su/Modals.js";


export default class PageProfilo extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    console.log("PageProfilo");

    // init form profilo
    let form = ".js-form-profilo";
    let btn_edit = ".js-change-user-info";
    let btn_changepw = ".js-changepw";
    let input_group_pw = ".js-input-group-pw";
    let btn_show_pw = ".js-showpw";
    if ($(form) && $(btn_edit)) {
      // matita entro in edit nel form
      $(btn_edit).on("click", (e) => {
        if (!$(form).hasClass("in-edit")) {
          $(form).addClass("in-edit");
        } else {
          $(form).removeClass("in-edit");
          if ($(input_group_pw).hasClass("is-visible")) {
            $(input_group_pw).removeClass("is-visible");
          }
        }
        if ($(input_group_pw).hasClass("is-visible")) {
          $(".js-hide-changepw").addClass("is-hidden");
        } else {
          $(".js-hide-changepw").removeClass("is-hidden");
        }
        for (let i = 0; i < $("input", form).length; i++) {
          $("input", form).attr("placeholder", "");
        }        
        if ($(".js-pw").val() > 0) {
          $(".js-pw").val("");
        }
      });

      // show password inputs on form
      /*
      $(btn_changepw).on("click", (e) => {
        if (!$(form).hasClass("in-edit")) {
          $(form).addClass("in-edit");
          if (!$(input_group_pw).hasClass("in-edit")) {
            $(input_group_pw).addClass("is-visible");
          } else {
            $(form).removeClass("in-edit");
            $(input_group_pw).removeClass("is-visible");
          }
        } else {
          if (!$(input_group_pw).hasClass("is-visible")) {
            $(input_group_pw).addClass("is-visible");
          } else {
            $(input_group_pw).removeClass("is-visible");
          }
        }
        if ($(input_group_pw).hasClass("is-visible")) {
          $(".js-hide-changepw").addClass("is-hidden");
        } else {
          $(".js-hide-changepw").removeClass("is-hidden");
        }
      });
      */

      // show password inputs values
      /*
      $(btn_show_pw).on("click", (e) => {
        let inputs = document.querySelectorAll(".js-pw");
        for (let i = 0; i < inputs.length; i++) {
          if (inputs[i].type === "password") {
            inputs[i].type = "text";
          } else {
            inputs[i].type = "password";
          }
        }
      });
      */

      // confronta pw inserite      
      // to be checked
      //let pw_inputs = document.querySelectorAll(".js-pw");
      //pw_inputs[1].addEventListener("change", (e) => {
      //  if (pw_inputs[0].value !== pw_inputs[1].value) {
      //    for (let i = 0; i < pw_inputs.length; i++) {
      //      pw_inputs[i].classList.add("has-error");
      //      $(".js-input-save").css({ "pointer-events": "none", "opacity": ".75" });
      //    }
      //  } else {
      //    for (let i = 0; i < pw_inputs.length; i++) {
      //      pw_inputs[i].classList.remove("has-error");
      //      $(".js-input-save").css({ "pointer-events": "all", "opacity": "1" });
      //    }
      //  }
      //});
      //pw_inputs[0].addEventListener("change", (e) => {
      //  if (pw_inputs[1].value.length !== 0) {
      //    if (pw_inputs[0].value !== pw_inputs[1].value) {
      //      for (let i = 0; i < pw_inputs.length; i++) {
      //        if (!pw_inputs[i].classList.contains("has-error")) {
      //          pw_inputs[i].classList.add("has-error");
      //          $(".js-input-save").css({ "pointer-events": "none", "opacity": ".75" });
      //        }
      //      }
      //    } else {
      //      for (let i = 0; i < pw_inputs.length; i++) {
      //        if (pw_inputs[i].classList.contains("has-error")) {
      //          pw_inputs[i].classList.remove("has-error");
      //          $(".js-input-save").css({ "pointer-events": "all", "opacity": "1" });
      //        }
      //      }
      //    }
      //  }        
      //});
    }

    $(".js-name").keyup(this.onCheckData.bind(this));
    $(".js-surname").keyup(this.onCheckData.bind(this));
    $(".js-input-save").on("click", this.onDoSubmit.bind(this));
    $("body").keydown(this.onSendData.bind(this));

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error();
    }
  }

  onCheckData() {
    let Name = $.trim($(".js-name").val());
    let Surname = $.trim($(".js-surname").val());

    if (Name !== "" && Surname !== "") {
      PageCommon.disable($(".js-input-save"), false);
      return true;
    } else {
      PageCommon.disable($(".js-input-save"), true);
      return false;
    }
  }

  onSendData(e) {
    if (e.which == 13 && this.onCheckData()) {
      this.onDoSubmit();
    }
  }

  onDoSubmit(e) {
    this.showPreloader(true);

    let FirstName = $.trim($(".js-name").val());
    let LastName = $.trim($(".js-surname").val());

    let data = {
      FirstName,
      LastName,
    }

    let rq = {
      Value: null,
      ContentLocale: TheApp.ContentLocale,
      Data: data
    }
    thatServiceManeger.standardCall("/api/auth/updateUserInfo", rq, this.onDoSubmitHandler.bind(this));

    // reload page
    location.reload();
  }

  onDoSubmitHandler(rs) {
    // console.log(rs);
    this.showPreloader(false);

    let showError = false;
    if (rs.StatusCode !== 200) {
      showError = true;
    } else {
      showError = !rs.Success;
    }

    if (showError) {
      let error = null;
      if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length > 0) {
        error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
        if (!error) {
          error = TheApp.Res[TheApp.Locale][rs.Errors[0].Code];
        }
        if (rs.Errors[0].RefsUid.length > 0) {
          error = error?.replace("{0}", rs.Errors[0].RefsUid);
        }
      }
      if (!error)
        error = TheApp.Res[TheApp.Locale]["ERROR.UPDATEPROFILE.DEFAULT"];

      let modal = new ModalAlert($("#template-modalAlert"));
      modal.create(
        {
          title: "ERRORE",
          body: error,
          close: "CHIUDI",
          error: true
        });
      modal.init();
      return;
    } else {
      let form = ".js-form-profilo";
      $(form).toggleClass("in-edit");
      $(".username").text(rs.Data.DisplayName);
    }
  }
}